import {Col, Row, Spin} from "antd";
import './style.scss'
import AccountCredential from "../../components/signup/accountCredential";
import {useEffect} from 'react';
import {homeLogo, xappHomeLogo} from '../../../AppImageConst';
import {useKeycloak} from "@react-keycloak/web";
import {useHistory} from "react-router-dom";


const SignUpPage = () => {
    const {keycloak} = useKeycloak();
    const  history = useHistory();
    useEffect(() => {
        if (keycloak && keycloak.authenticated) {
            history.push(`/workflow/customer/dashboard`)
        }
    }, [])
    return (
        <>
            {keycloak.authenticated ?
                <div className="loader-container">
                    <Spin size="large" tip="Loading"></Spin>
                </div> :
                <div className='account_credentials_screen_main'>
                    <Row gutter={0} className='main-row'>
                        <Col lg={12} md={{span: 0}} sm={{span: 0}} hidden className='left-side-main-container'>
                            <Row gutter={0} className='main-row'>
                                <Col span={24}>
                                    <div className="clip-path-img">
                                        <div className='clip-path-img-container text-center'>
                                            <img src={xappHomeLogo} className={'w-20'} alt="logo"/>
                                        </div>
                                    </div>
                                </Col>
                                <Col span={24} className='left-side-title-container'>
                                    <h1 className='left-side-main-title'>Manage</h1>
                                    <h1 className='left-side-main-title'>YOUR WEALTH</h1>
                                    <div className="header_divider"></div>
                                    <h2 className='left-side-sub-title'>- No paperwork, No stress - </h2>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12} md={24} sm={24} className='text-input-col'>
                            <AccountCredential/>
                        </Col>
                    </Row>
                </div>
            }
        </>
    )

}
export default SignUpPage;

